export const INITIAL_TABLE_OFFSET = 0;

export const INITIAL_TABLE_PAGE = 1;

export const INITIAL_TABLE_LIMIT = 10;

export const TABLE_PATH = ["name", "description", "is_active"]

export const TABLE_HEADING = (t) => [
    { title: t("Name"), field: "name" },
    { title: t("Description"), field: "description" },
    { title: t("Status"), field: "is_active" },
    { title: "", field: "icon" },
]

export const TABLE_TYPE = [
    { type: ["long_text"], name: "name" },
    { type: ["long_text"], name: "description" },
    { type: ["status"], name: "is_active" },
    { type: ["more_4"], icon: "icon" },
]

export const INITIAL_ADD_FORM_STATE = {
    form_type: "add",
    id: "",
    name: "",
    description: "",
    is_active: true,
    is_delete: false,
    error: {
        name: "",
        description: "",
    }
}

export const INITIAL_FILTER_STATE = { is_active: [true] }